exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'blogpost') return `/news/${doc.uid}/`
  if (doc.type === 'team_member') return `/team/${doc.slug}/`
  return '/'
}
